module.exports = __webpack_public_path__ + "img/bena.00cb7fbf.jpg";